module.exports = __webpack_public_path__ + "img/avatar-74.e7d615be.png";